import React from 'react';
import { connect } from 'react-redux';
import { fetchEventDetails } from '../../actions/event';
import { fetchResponses } from '../../actions/responses';
import './HistoricalTrend.css';
import LineChart from '../charts/LineChart';
import { lineGraph } from '../charts/templates/lineGraph';
import Event from '../../models/Event';
import DateTime from '../../models/DateTime';
import ErrorAndRefresh from '../shared/ErrorAndRefresh';
import { handleError } from '../../util/Errors';
import PulseStats from '../../models/PulseStats';
import { eventApi } from '../../api/EventApi';
import Logger from '../../util/Logger';
import { CreatorReportAnalytics } from '../../analytics/CreatorReportAnalytics';

class HistoricalTrend extends React.Component {

  handleOnChartItemClicked = (clickEvent) => {
    const { editing, event, onChartIndexClicked } = this.props;

    // Don't do anything on click if we are in edit mode.
    if (!!editing) {
      return;
    }

    const { point } = clickEvent;
    if (point) {
      const { extras } = point;
      if (extras) {
        const { index, eventId } = extras;
        if (eventId !== Event.getId(event)) {

          // Yeah we should be using a saga. But I've been typing at this for a while
          // now and have some frustrations around the fact that a PulseStats object is not only
          // not a mini event - its not even Event like since instead of things like
          // id and slug, it prefixes everything with event_id and event_slug. Why.
          // Also times are not unix seconds like everywhere else , they are time stamps.
          // Why.
          eventApi.getDetails(eventId)
            .then(event => {
              Logger.info('Inline Promise finished and you should feel bad.');
              // Index is 0 indexed
              CreatorReportAnalytics.historicalTrendClicked(index + 1);
              onChartIndexClicked(event);
            });
        }
      }
    }
  };

  componentDidUpdate (prevProps) {
    const { pulseStatsError } = this.props;
    handleError(pulseStatsError, prevProps.pulseStatsError);
  }

  loadStats = () => {
    const { fetchEventDetails, fetchResponses, event } = this.props;
    fetchEventDetails(Event.getId(event));
    fetchResponses(Event.getId(event));
  };

  formatTooltip = (tooltip) => {
    const moment = DateTime.unixSecondsToMoment(tooltip.x / 1000);
    const formatted = DateTime.format(moment, 'ddd, MMM DD, YYYY');
    return (`
    <div class="col">
      <div class="row no-gutters h-100 text-nowrap p-0 m-0" style="margin-left: -1rem !important; margin-right: -1rem !important;">
        <div class="text-left fix-ie font-weight-bold mb-1">${formatted}</div>
      </div>
      <div class="row no-gutters h-100 text-nowrap p-0 m-0" style="margin-left: -1rem !important; margin-right: -1rem !important;">
        <div class="text-left fix-ie">Average: ${tooltip.y}</div>
      </div>
    </div>
     `).trim();
  };

  render () {
    const { event, pulseStats, pulseStatsError, isPdfRender } = this.props;

    if (pulseStatsError || !pulseStats) {
      return (
        <div className="historical-trend">
          <ErrorAndRefresh
            error="Failed to load Historical Trend Data"
            onRefresh={ this.loadStats }
          />
        </div>
      );
    }

    const chartData = [];
    let pointStart = null;
    let pointInterval = null;

    pulseStats.forEach((stats, index) => {
      const startTime = PulseStats.getEventStartTime(stats);
      const endTime = PulseStats.getEventEndTime(stats);

      if (index === 0) {
        pointStart = endTime * 1000; // server returns seconds - Highcharts needs millis
        pointInterval = (endTime - startTime) * 1000; // server returns seconds - Highcharts needs millis
      }

      const currentEventId = Event.getId(event);
      const pulseEventId = PulseStats.getEventId(stats);
      const newDataItem = {
        x: DateTime.momentToUnixSeconds(startTime) * 1000,
        extras: {
          index,
          eventId: pulseEventId
        },

        // TODO Better color
        // Color the currently active dot different
        color: currentEventId === pulseEventId ? 'green' : null
      };

      // If there is no simple score, nobody voted
      const score = PulseStats.getSimpleScore(stats);
      if (score === null || score === undefined) {
        newDataItem.y = 0;
      } else {
        newDataItem.y = score;
      }
      chartData.push(newDataItem);
    });

    const data = [
      {
        name: 'Average Rating',
        data: chartData,
        pointStart: pointStart,
        pointInterval: pointInterval
      }
    ];

    return (
      <div>
        <div className="row no-gutters historical-trend print-card-header">
          <LineChart
            chartType={ lineGraph }
            chartId="Historical Trend"
            data={ data }
            customChartContainerClass="trend-chart-container"
            customChartClass="trend-chart"
            forceReflowBecauseOfBug={ true }
            disableAnimation={ isPdfRender }
            tooltipFormatter={ this.formatTooltip }
            onClick={ this.handleOnChartItemClicked }
          />
        </div>
      </div>
    );
  }

}

const mapStateToProps = state => {
  const user = state.user.user;
  return {
    user: user,
    event: state.event.event,
    pulseStatsError: state.event.pulseStatsError
  };
};

export default connect(mapStateToProps, {
  fetchEventDetails,
  fetchResponses
})(HistoricalTrend);
